"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.ai.title': 'Chiedi all\'assistente AI',
    'socialMediaPlan.ai.desc': 'L\'assistente analizza la tua libreria.',
    'socialMediaPlan.ai.preset.topics': 'Migliori argomenti?',
    'socialMediaPlan.ai.preset.plan': 'Piano contenuti settimana prossima',
    'socialMediaPlan.ai.preset.timing': 'Quando pubblicare?',
    'socialMediaPlan.ai.preset.summary': 'Riepilogo mensile',
    'socialMediaPlan.ai.placeholder': 'Chiedi es. 3 idee per Instagram...',
    'socialMediaPlan.ai.ask': 'Chiedi AI',
    'socialMediaPlan.ai.error': 'Errore assistente AI.',
};
